// extracted by mini-css-extract-plugin
export var label = "_df-2";
export var slideContainer = "_df-0";
export var slider = "_df-1";